<!-- Polaris (fase 5.5, D-G5): no company yet. Faded rows of the real companies table behind (sample companies, an
     illustration hidden from assistive tech) and the kit's Empty in front with "New company". -->
<script setup>
import { useI18n } from 'vue-i18n';
import { Add16 } from '@carbon/icons-vue';
import CompaniesCard from 'dashboard/components-next/Companies/CompaniesCard/CompaniesCard.vue';
import { Button } from 'dashboard/components-next/polaris/ui/button';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyTitle,
} from 'dashboard/components-next/polaris/ui/empty';
import { Table, TableBody } from 'dashboard/components-next/polaris/ui/table';

const emit = defineEmits(['create']);

const { t } = useI18n();

const NOW = Math.floor(Date.now() / 1000);
const SAMPLES = [
  ['Loja Exemplo', 'lojaexemplo.com', 12],
  ['Comércio Aurora', 'aurora.example.com', 4],
  ['Clínica Horizonte', 'horizonte.example.com', 7],
  ['Distribuidora Norte', 'norte.example.com', 2],
  ['Papelaria Central', 'papelariacentral.example.com', 9],
].map(([name, domain, contactsCount], index) => ({
  id: index + 1,
  name,
  domain,
  contactsCount,
  lastActivityAt: NOW - (index + 1) * 86400,
}));
</script>

<template>
  <section
    class="relative flex h-full min-h-[24rem] w-full flex-col overflow-hidden"
    data-companies-empty
  >
    <div
      class="pointer-events-none max-h-[24rem] overflow-hidden opacity-50"
      aria-hidden="true"
      inert
    >
      <Table>
        <TableBody>
          <CompaniesCard
            v-for="company in SAMPLES"
            :id="company.id"
            :key="company.id"
            inert
            :name="company.name"
            :domain="company.domain"
            :contacts-count="company.contactsCount"
            :last-activity-at="company.lastActivityAt"
          />
        </TableBody>
      </Table>
    </div>
    <div
      class="absolute inset-0 flex items-end justify-center bg-gradient-to-t from-polaris-background from-40% to-transparent pb-12"
    >
      <Empty class="flex-none">
        <EmptyHeader>
          <EmptyTitle class="type-polaris-section-title">
            {{ t('COMPANIES.EMPTY_STATE.TITLE') }}
          </EmptyTitle>
          <EmptyDescription>
            {{ t('COMPANIES_POLARIS.EMPTY.DESCRIPTION') }}
          </EmptyDescription>
        </EmptyHeader>
        <EmptyContent>
          <Button size="sm" @click="emit('create')">
            <Add16 aria-hidden="true" />
            {{ t('COMPANIES.ACTIONS.CREATE') }}
          </Button>
        </EmptyContent>
      </Empty>
    </div>
  </section>
</template>
